import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { hashHistory } from 'react-router';
import api from '../../api/Categories.api.js';
import xhr from './../../utils/xhr';
import Spinnable from '../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper';
import { FormattedMessage } from 'react-intl';
import CategoryForm from './Components/CategoryForm';
import headerActions from './../../reusable/Header/Header.actions';
import popupActions from '../../reusable/MessagePopup/redux/MessagePopup.actions';
import {
    POPUP_LIFETIME,
} from './../../constants';

class EditCategoryPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validated: false,
            values: null,
            pendingRequestSpinner: false,
            errorMessage: null,
            showErrors: false
        };

        this.setValidationState = this.setValidationState.bind(this);
        this.onChange = this.onChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        headerActions.updateHeader('editCategory');
        this.props.spinner.showSpinner();
        api.getCategoryData(this.props.routeParams.categoryId)
            .then((response) => {
                const values = {
                    name: response.body.name,
                    entityIds: response.body.companies
                }
                this.setState({ values, validated: true });
                this.props.spinner.hideSpinner();
            }).catch((error) => {
                console.log("********************** Edit Category Load Failed ********************");
                xhr.handleAllErrors(error);
            });
    }

    onChange(values) {
        this.setState({ values, errorMessage: null });
    }

    requestUpdateCategory() {
        if (this.state.validated) {
            this.setState({ pendingRequestSpinner: true });
            api.updateCategory({
                name: this.state.values.name,
                companies: this.state.values.entityIds,
                categoryId: this.props.routeParams.categoryId
            }).then((response) => {
                    this.showRequestStatusPopup('Category_Create_UIText_creationSuccess', 'success');
                    hashHistory.push('/categories');
                }).catch((error) => {
                this.showRequestStatusPopup('General_CoreFunctionality_Error_general.saveError', 'system-error');
                this.setState({pendingRequestSpinner: false});
                console.log("********************** Category Save Failed ********************");
            });
        } else {
            this.setState({errorMessage: 'Category_Create_UIText_addCategory.entities.error'});
        }
    }

    showRequestStatusPopup(messageId, messageType) {
        popupActions.setMessages({
            popupTitle: null,
            messages:   [
                {
                    messageId:   messageId,
                    values:      { categoryName: this.state.values.name },
                    messageType: messageType
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    setValidationState(state) {
        this.setState({ validated: state })
    }

    cancelButtonRedirect() {
        hashHistory.push("/categories");
    }

    submit() {
        if (this.state.validated && this.state.values.entityIds.length) {
            this.requestUpdateCategory();
        } else {
            this.setState({ showErrors: true })
        }
    }

    render = () => (
        <div className="edit-category-form category-form">
            { this.state.errorMessage && <FormattedMessage id={this.state.errorMessage}/>}
            {this.state.values &&
                <CategoryForm values={this.state.values}
                              setValidationState={this.setValidationState}
                              onChange={this.onChange}
                              showErrors={this.state.showErrors}
                              categoryId={this.props.routeParams.categoryId} />
            }
            <div className='category-page__navigation'>
                {
                    !this.props.pendingRequestSpinner ?
                        <button type='button'
                                className='button-primary-lg'
                                onClick={this.submit}
                                disabled={!this.state.values || !this.state.values.name}>
                            <FormattedMessage id="General_CoreFunctionality_UIText_general.save" />
                        </button>
                        :
                        <div className='inline-spinner' />
                }
                <button type='button'
                        className='button-secondary-lg'
                        onClick={this.cancelButtonRedirect}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />
                </button>
            </div>
        </div>
    );
}

export default withRouter(Spinnable(EditCategoryPage));


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/EditCategoryPage.jsx